module.exports = __webpack_public_path__ + "img/downarrow-requested-changes.3262cffa.svg";